module.exports = __webpack_public_path__ + "img/addBank.1545f7b0.png";